import { Module } from 'vuex-smart-module';
import CommercialOffersActions from './actions';
import CommercialOffersGetters from './getters';
import CommercialOffersMutations from './mutations';
import CommercialOffersState from './state';

export default new Module({
  state: CommercialOffersState,
  mutations: CommercialOffersMutations,
  actions: CommercialOffersActions,
  getters: CommercialOffersGetters,
});
